import React, { useState } from 'react'
import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import type { Active, UniqueIdentifier } from '@dnd-kit/core'

import { DragOverlay } from './DragOverlay.component'

interface Item {
  id: UniqueIdentifier
  data?: any
}

interface Zone {
  id: UniqueIdentifier
  data?: any
}

interface Props {
  onDragStart?: (props: { item: Item }) => void
  onDragEnd?: (props: { item: Item; zone?: Zone }) => void
  onDragCancel?: () => void
  renderItem: (props: { item: Item }) => React.ReactNode
  children: React.ReactNode
  disabled?: boolean
}

export const DragAndDropContext = (props: Props) => {
  const { onDragStart, onDragEnd, onDragCancel, renderItem, disabled = false, children } = props

  const [active, setActive] = useState<Active | null>(null)

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  )

  return (
    <DndContext
      sensors={sensors}
      onDragStart={({ active }) => {
        if (disabled) return

        setActive(active)
        onDragStart?.({ item: { id: active.id, data: active.data.current } })
      }}
      onDragEnd={({ active, over }) => {
        if (disabled) return

        onDragEnd?.({
          item: { id: active.id, data: active.data.current },
          zone: over ? { id: over.id, data: over.data.current } : undefined,
        })

        setActive(null)
      }}
      onDragCancel={() => {
        if (disabled) return

        onDragCancel?.()

        setActive(null)
      }}
    >
      {children}

      <DragOverlay>{active ? renderItem({ item: { id: active.id, data: active.data.current } }) : null}</DragOverlay>
    </DndContext>
  )
}
